module.exports = __webpack_public_path__ + "assets/fonts/fontawesome-webfont.674f50d.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 455
// module chunks = 66